import React from 'react';
import PropTypes from 'prop-types';

const Angle1Path = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M5 6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3.001h14c1.656 0 3-1.344 3-3.001V9a3 3 0 0 0-3-3H5zm4 5.711c.704-.034 1.195-.084 1.477-.151.447-.107.812-.32 1.093-.64.194-.219.316-.542.415-.907.004-.014.009-.016.015-.009V10h2v12h-2v-8.887H9.046L9 11.711zm21.882-4.082l-6.627 3.728a.5.5 0 0 0-.255.435v8.416a.5.5 0 0 0 .255.435l6.627 3.729A.75.75 0 0 0 32 23.717V8.282a.75.75 0 0 0-.751-.749.738.738 0 0 0-.367.096z"
    />
  );
};

Angle1Path.propTypes = {
  fill: PropTypes.string,
};

export default Angle1Path;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/angle-1.jsx